import { Button } from "@design-lab/shared/ui/design-system/Button";
import { Tooltip, TooltipTrigger } from "@design-lab/shared/ui/design-system/Tooltip";

type SizeItemTooltipProps = {
  isOpen: boolean;
  variant: "error" | "warning";
  children: React.ReactNode;
};

export function SizeItemTooltip({ isOpen, variant, children }: SizeItemTooltipProps) {
  const borderColor = variant === "error" ? "border-red-500" : "border-amber-500";
  const ariaLabel = variant === "error" ? "Inventory error" : "Fast delivery warning";

  return (
    <TooltipTrigger isOpen={isOpen} delay={0}>
      <Button
        aria-label={ariaLabel}
        className="absolute inset-0 cursor-default rounded-none border-none bg-transparent shadow-none"
        style={{ pointerEvents: "none" }}
      />
      <Tooltip
        placement="top"
        showArrow={false}
        offset={8}
        className={`bg-background whitespace-nowrap border px-3 py-2 text-sm text-gray-700 shadow-xl ${borderColor}`}
      >
        {children}
      </Tooltip>
    </TooltipTrigger>
  );
}
